import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const API = axios.create({ baseURL: API_URL });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Events
export const getEvents = () => API.get('/events');
export const getEvent = (id) => API.get(`/events/${id}`);

// Auth
export const login = (data) => API.post('/auth/login', data);
export const register = (data) => API.post('/auth/register', data);
export const getCurrentUser = () => API.get('/auth/me');
export const updatePreferences = (data) => API.put('/auth/preferences', data);

// Payments/Bookings
export const checkout = (data) => API.post('/payments/checkout', data);
export const getMyBookings = () => API.get('/payments/my-bookings');
